"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrollmentMatchToJSON = exports.EnrollmentMatchFromJSONTyped = exports.EnrollmentMatchFromJSON = void 0;
function EnrollmentMatchFromJSON(json) {
    return EnrollmentMatchFromJSONTyped(json, false);
}
exports.EnrollmentMatchFromJSON = EnrollmentMatchFromJSON;
function EnrollmentMatchFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enrollmentId': json['enrollmentId'],
    };
}
exports.EnrollmentMatchFromJSONTyped = EnrollmentMatchFromJSONTyped;
function EnrollmentMatchToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'enrollmentId': value.enrollmentId,
    };
}
exports.EnrollmentMatchToJSON = EnrollmentMatchToJSON;
//# sourceMappingURL=EnrollmentMatch.js.map